/**
 * index.js
 *
 * Main project entry point. Import all the initial scaffolding files here.
 *
 */

// Project-wide JS
import 'babel-polyfill'; // required by React & es6 scripts to work on IE11
import LazyLoad from 'vanilla-lazyload';
import './utils/support';
import '../components/components';
import '../sections/sections';
import '../content-widgets/content-widgets';
import '../styleguide/styleguide';
import './file-uploader';

const lazyLoadConfig = { elements_selector: '[data-lazy]' };
if (!document.lazyLoadInstance) {
    document.lazyLoadInstance = new LazyLoad(lazyLoadConfig);
}



// WEBPACK FOOTER //
// ./src/js/scripts.js